import React from 'react';
import { Popover, Button } from 'antd';
import KoStaicGroups from 'packages/staticgroup';
import styles from './sharedWith.module.scss';

export default function SharedWithGroups({ data }) {
  let groups = data?.groups || [];

  const visibleGroups = groups.slice(0, 1) || [];
  const hiddenGroups = groups.slice(1) || [];

  const renderPopoverContent = () => (
    <div className={styles.popoverContent}>
      {hiddenGroups.map((group, index) => (
        <KoStaicGroups key={`group-${index}`} data={group?.profile} />
      ))}
    </div>
  );

  return (
    <div className={styles.wrapper}>
      {visibleGroups.map((group, index) => (
        <KoStaicGroups key={`visible-group-${index}`} data={group?.profile} />
      ))}

      {(hiddenGroups.length > 0) && (
        <Popover content={renderPopoverContent()}>
          <Button type="link" className={styles.moreButton}>
            +{hiddenGroups.length } more
          </Button>
        </Popover>
      )}
    </div>
  );
}
